import React, { Suspense, lazy } from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import { SuspenseLoader } from './shared/components/SuspenseLoader.tsx'
import { ProtectedRoute } from './shared/components/ProtectedRoute.tsx'

const ViAFAMPage = lazy(() => import('./pages/ViAFAM/ViAFAMPage.tsx'))
const ViAFITPage = lazy(() => import('./pages/ViAFIT/ViAFITPage.tsx').then(m => ({ default: m.StationPage })))
const ViZSimPage = lazy(() => import('./pages/ViZSim/ViZSimPage.tsx'))
const BlogPage   = lazy(() => import('./pages/Blog/BlogPage.tsx'))
const BlogArticlePage = lazy(() => import('./pages/Blog/BlogArticlePage.tsx'))
const NewsPage   = lazy(() => import('./pages/News/NewsPage.tsx'))
const NewsArticlePage = lazy(() => import('./pages/News/NewsArticlePage.tsx'))
const JobsPage   = lazy(() => import('./pages/Jobs/JobsPage.tsx'))

// Admin pages
const LoginPage        = lazy(() => import('./pages/Admin/LoginPage.tsx'))
const AdminLayout      = lazy(() => import('./pages/Admin/AdminLayout.tsx'))
const ArticleListPage  = lazy(() => import('./pages/Admin/ArticleListPage.tsx'))
const ArticleEditorPage = lazy(() => import('./pages/Admin/ArticleEditorPage.tsx'))
const UserListPage     = lazy(() => import('./pages/Admin/UserListPage.tsx'))
const MediaPage           = lazy(() => import('./pages/Admin/MediaPage.tsx'))
const CategoryListPage    = lazy(() => import('./pages/Admin/CategoryListPage.tsx'))
const ProfilePage         = lazy(() => import('./pages/Admin/ProfilePage.tsx'))

export default function AppRouter() {
  return (
    <Suspense fallback={<SuspenseLoader />}>
      <Routes>
        {/* Public pages */}
        <Route path="/ViAFAM" element={<ViAFAMPage />} />
        <Route path="/ViAFIT" element={<ViAFITPage />} />
        <Route path="/ViZSim" element={<ViZSimPage />} />
        <Route path="/blog"   element={<BlogPage />} />
        <Route path="/blog/:slug" element={<BlogArticlePage />} />
        <Route path="/news"   element={<NewsPage />} />
        <Route path="/news/:slug" element={<NewsArticlePage />} />
        <Route path="/jobs"   element={<JobsPage />} />

        {/* Admin */}
        <Route path="/admin/login" element={<LoginPage />} />
        <Route path="/admin" element={<ProtectedRoute><AdminLayout /></ProtectedRoute>}>
          <Route index element={<Navigate to="articles" replace />} />
          <Route path="articles" element={<ArticleListPage />} />
          <Route path="articles/new" element={<ArticleEditorPage />} />
          <Route path="articles/:id" element={<ArticleEditorPage />} />
          <Route path="users" element={<ProtectedRoute requiredRole="admin"><UserListPage /></ProtectedRoute>} />
          <Route path="media" element={<MediaPage />} />
          <Route path="categories" element={<ProtectedRoute requiredRole="admin"><CategoryListPage /></ProtectedRoute>} />
          <Route path="profile" element={<ProfilePage />} />
        </Route>

        {/* Default */}
        <Route path="/" element={<Navigate to="/ViAFIT" replace />} />
        <Route path="*" element={<Navigate to="/ViAFIT" replace />} />
      </Routes>
    </Suspense>
  )
}
